"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.0001 4.16666C20.8796 4.16666 16.8517 5.38852 13.4257 7.67771C9.99969 9.96691 7.32943 13.2206 5.7526 17.0274C4.17577 20.8342 3.76321 25.0231 4.56706 29.0644C5.37092 33.1056 7.35511 36.8178 10.2687 39.7314C13.1823 42.645 16.8944 44.6292 20.9357 45.433C24.977 46.2369 29.1659 45.8243 32.9727 44.2475C36.7795 42.6707 40.0332 40.0004 42.3224 36.5744C44.6116 33.1484 45.8334 29.1204 45.8334 25C45.8334 22.2641 45.2946 19.555 44.2476 17.0274C43.2006 14.4998 41.666 12.2032 39.7315 10.2686C37.7969 8.33405 35.5003 6.79948 32.9727 5.75251C30.445 4.70553 27.736 4.16666 25.0001 4.16666ZM25.0001 42.625C21.5042 42.625 18.0869 41.5878 15.1807 39.6447C12.2745 37.7016 10.0102 34.94 8.67427 31.7094C7.33836 28.4788 6.99094 24.9245 7.67599 21.4964C8.36105 18.0682 10.0478 14.9204 12.5227 12.4514C14.9976 9.98231 18.1494 8.30302 21.5791 7.62606C25.0088 6.9491 28.5623 7.30491 31.7898 8.64845C35.0172 9.99199 37.7734 12.2629 39.7097 15.1736C41.6459 18.0843 42.675 21.5041 42.6668 25C42.6668 29.6855 40.8055 34.1791 37.4923 37.4922C34.1792 40.8054 29.6856 42.6667 25.0001 42.6667V42.625Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M34.0834 24H27.0834V13.0417C27.0834 12.6273 26.9188 12.2298 26.6258 11.9368C26.3328 11.6438 25.9353 11.4792 25.5209 11.4792C25.1065 11.4792 24.7091 11.6438 24.4161 11.9368C24.123 12.2298 23.9584 12.6273 23.9584 13.0417V25.5417C23.9638 25.9544 24.1302 26.3487 24.422 26.6406C24.7139 26.9324 25.1082 27.0988 25.5209 27.1042H34.1876C34.602 27.1042 34.9994 26.9395 35.2924 26.6465C35.5855 26.3535 35.7501 25.9561 35.7501 25.5417C35.7501 25.1273 35.5855 24.7298 35.2924 24.4368C34.9994 24.1438 34.602 23.9792 34.1876 23.9792L34.0834 24Z",
    fill: fill
  }));
};

exports["default"] = _default;